import { validatePix } from '~/helpers/validation/pix';

export type ValidatePixStep =
  | { kind: 'idle' }
  | { kind: 'formatError' }
  | { kind: 'loading' }
  | { kind: 'result'; isValid: boolean }
  | { kind: 'requestError' };

export function resolvePixInput(rawInput: string): { kind: 'proceed'; normalized: string } | { kind: 'formatError' } {
  const result = validatePix(rawInput);

  if (result.kind === 'invalid') {
    return { kind: 'formatError' };
  }

  return { kind: 'proceed', normalized: result.normalized };
}
